export default "__VITE_ASSET__DfEJOXn7__"